import { TranslationDictionary } from 'core/localization/localization';

let sharedDictionary: TranslationDictionary = null;
const bundles = require.context('../../../', true, /translations$/);

// Loading all translation bundles eagerly as a module-level side effect would re-enter this
// module (via require.context) before its own exports are registered, since the very first
// Localization instance is created as a module-level side effect (see `i` below). Building it
// lazily on first use avoids that circular-require ordering issue, while the module-level
// `sharedDictionary` variable ensures the work only happens once and is reused by every instance.
export function getSharedDictionary(): TranslationDictionary {
	if (sharedDictionary != null) return sharedDictionary;

	sharedDictionary = {};

	for (const fileName of bundles.keys()) {
		const bundle = bundles(fileName) as {
			translations: TranslationDictionary;
		};

		if (bundle.translations) {
			for (const key of Object.keys(bundle.translations)) {
				if (sharedDictionary[key] != null) {
					console.log(`The key ${key} already exists in the dictionary. Bundle: ${fileName}`);
				}
				sharedDictionary[key] = bundle.translations[key];
			}
			Object.assign(sharedDictionary, bundle.translations);
		}
	}

	return sharedDictionary;
}
